import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Box, Container, Grid } from '@mui/material';
import { Star } from 'lucide-react';
import Heading from '../../Components/Heading';
import Paragraph from '../../Components/Paragraph';
import Aos from 'aos';
import layerbg from '../../../assets/layerbg.png';
const LayerImage = styled.img`
    position: absolute;
    top: 100px;
    left: 0;
    width: 100%;
    height: 100%;
    /* object-fit: cover;  */
    opacity: 0.5;
    pointer-events: none; 
    z-index: 0; 
    @media (max-width: 600px) {
    display: none;
  }
`;

const Wrapper = styled(Box)`
  padding: 120px 0px;
  position: relative;
`;

const TestimonialCard = styled(Box)`
  background: #080411;
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s ease;
  border: 1px solid #222222;
  height: 290px;
  display: flex;
  flex-direction: column; 
  /* &:hover {
    border-color: #8b5cf6;
    transform: translateY(-4px);
  } */
`;

const DateText = styled.div`
  font-size: 18px;
  margin-top: auto; 
`;


const UserInfo = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const Avatar = styled(Box)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 17px;
  background: ${props => props.bgColor};
`;

const UserDetails = styled(Box)`
  flex: 1;
`;

const UserId = styled.div`
  color: white;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 4px;
`;

const StarsContainer = styled(Box)`
  display: flex;
  gap: 2px;
`;


const testimonials = [
  {
    id: '4d',
    userId: '0x44...Eb44',
    rating: 5,
    text: "I can honestly say that the speeds i experience with shadow node are unparalleled. i have never experience any kind of network speed throttling whenever i use svpn.",
    date: 'April 25, 2024',
    bgColor: '#8b5cf6'
  },
  {
    id: '99',
    userId: '0xc0...8A99',
    rating: 5,
    text: "I've been using this VPN everyday and I sometimes forget that I'm connected to it. The speed is lightening fast and simple to use.",
    date: 'April 25, 2024',
    bgColor: '#7c3aed'
  },
  {
    id: 'D2',
    userId: '0xD4...BbD2',
    rating: 5,
    text: "用不了，只有一个设备才能用，一直闪退",
    date: 'July 25, 2024',
    bgColor: '#8b5cf6'
  }
];

const Users = () => {
    useEffect(() => {
      
          Aos.init({
            duration: 1200,
            offset: 100,
            once: true, 
            easing: 'ease-out-cubic',
            mirror: false,
          });
        }, []);
  return (
    <Wrapper id='testimonials' >
       <LayerImage src={layerbg} alt="Layer Background" />
      <Container maxWidth='xl'> 
        <Grid container justifyContent={'center'} textAlign={'center'} mb={4}>
          <Grid item>
            <Heading style={{marginBottom:'20px'}} data-aos="fade-up" data-aos-once="false">
              What Our Users{' '}
              <span style={{
                background: "linear-gradient(160deg, rgb(197, 180, 226) 43%, rgb(168, 96, 255)) text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 'bolder'
              }}>
                Are Saying
              </span>
            </Heading>
            <Paragraph data-aos="fade-up" data-aos-once="false">Trusted by thousands worldwide.</Paragraph>
          </Grid>
        </Grid>

        <Grid container spacing={3} style={{justifyContent:'center'}}>
          {testimonials.map((testimonial) => (
            <Grid item xs={12} md={6} lg={3.5} key={testimonial.id}>
              <TestimonialCard data-aos="fade-up" data-aos-once="false">
                <UserInfo>
                  <Avatar bgColor={testimonial.bgColor}>
                    {testimonial.id}
                  </Avatar>
                  <UserDetails>
                    <UserId>{testimonial.userId}</UserId>
                    <StarsContainer>
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star 
                          key={i} 
                          size={20} 
                          fill="#8b5cf6" 
                          color="#8b5cf6" 
                        />
                      ))}
                    </StarsContainer>
                  </UserDetails>
                </UserInfo>

                <Paragraph>
                  {testimonial.text}
                </Paragraph>

                <DateText>
                  {testimonial.date}
                </DateText>
              </TestimonialCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Wrapper>
  );
};

export default Users;